// bundle-manager.js

(function (window, $) {
  // =========== CONFIG ===========
  // Set this to the current product ID on each product page (number or string)
  var currentProductId = $('custom-build-product').attr('data-pid');

  // =========== LOCAL STORAGE UTILS ===========
  function getBundlesFromLocal() {
    var data = localStorage.getItem('bundle_groups');
    return data ? JSON.parse(data) : [];
  }

  function saveBundlesToLocal(bundles) {
    localStorage.setItem('bundle_groups', JSON.stringify(bundles));
  }

  // =========== METAFIELD SYNC ===========
  // Identity is taken server-side from the signed App Proxy logged_in_customer_id
  // param — never from the request body (closes the prior IDOR). window.customer_id
  // is only the client-side "am I logged in" gate at the call sites.
  function saveBundlesToMetafield(bundles) {
    return $.ajax({
      url: '/apps/garage/bundles/save',
      type: 'POST',
      data: JSON.stringify({ bundles: bundles }),
      contentType: 'application/json'
    });
  }

  function loadBundlesFromMetafield() {
    return $.ajax({
      url: '/apps/garage/bundles/load',
      type: 'GET',
      cache: false // customer-specific; avoid a stale browser-cached load
    });
  }

  function resetBundlesOnServer() {
    return $.ajax({
      url: '/apps/garage/bundles/reset',
      type: 'POST'
    });
  }

  // =========== BUNDLE MANIPULATION ===========
  function saveOrUpdateBundleByProduct(bundle) {
    var bundles = getBundlesFromLocal();
    var idx = bundles.findIndex(function (b) { return b.main_product.id === bundle.main_product.id; });
    if (idx >= 0) {
      bundles[idx] = bundle;
    } else {
      bundles.push(bundle);
    }
    saveBundlesToLocal(bundles);
    if (window.customer_id) saveBundlesToMetafield(bundles);
  }

  function getBundleByProductId(productId) {
    var bundles = getBundlesFromLocal();
    return bundles.find(function (b) { return b.main_product.id === productId; }) || null;
  }

  function deleteBundleByProductId(productId) {
    var bundles = getBundlesFromLocal().filter(function (b) { return b.main_product.id !== productId; });
    saveBundlesToLocal(bundles);
    if (window.customer_id) saveBundlesToMetafield(bundles);
  }

  function resetAllBundles() {
    localStorage.removeItem('bundle_groups');
    if (window.customer_id) resetBundlesOnServer();
  }

  // =========== UI INTEGRATION EXAMPLES ===========
  // Call this on page load to restore bundle state for the current product
  function restoreBundleForCurrentProduct(restoreCallback) {
    var productId = currentProductId;

    // If logged in, always check metafield first
    if (window.customer_id) {
      loadBundlesFromMetafield().done(function (resp) {
        if (resp && resp.success && Array.isArray(resp.bundles)) {
          saveBundlesToLocal(resp.bundles); // sync localStorage for offline
          var bundle = resp.bundles.find(function (b) {
            return String(b.main_product.id) == String(productId);
          }) || null;

          // Prefer metafield data if found
          if (bundle && restoreCallback) return restoreCallback(bundle);

          // If metafield has no bundle for this product, try localStorage as fallback
          var localBundle = getBundlesFromLocal().find(function (b) {
            return String(b.main_product.id) == String(productId);
          }) || null;
          if (localBundle && restoreCallback) return restoreCallback(localBundle);

          // If nothing found, still call the callback with null
          if (restoreCallback) return restoreCallback(null);
        } else {
          // API fail or bad data: fallback to localStorage
          var localBundle = getBundlesFromLocal().find(function (b) {
            return String(b.main_product.id) == String(productId);
          }) || null;
          if (restoreCallback) return restoreCallback(localBundle);
        }
      }).fail(function() {
        // On API error, fallback to localStorage
        var localBundle = getBundlesFromLocal().find(function (b) {
          return String(b.main_product.id) == String(productId);
        }) || null;
        if (restoreCallback) return restoreCallback(localBundle);
      });
      return; // Don't run local check yet
    }

    // Not logged in: use only localStorage
    var bundle = getBundlesFromLocal().find(function (b) {
      return String(b.main_product.id) == String(productId);
    }) || null;
    if (restoreCallback) restoreCallback(bundle);
  }


  // =========== EXPORTS ===========
  window.BundleManager = {
    getBundlesFromLocal: getBundlesFromLocal,
    saveBundlesToLocal: saveBundlesToLocal,
    saveBundlesToMetafield: saveBundlesToMetafield,
    loadBundlesFromMetafield: loadBundlesFromMetafield,
    saveOrUpdateBundleByProduct: saveOrUpdateBundleByProduct,
    getBundleByProductId: getBundleByProductId,
    deleteBundleByProductId: deleteBundleByProductId,
    resetAllBundles: resetAllBundles,
    restoreBundleForCurrentProduct: restoreBundleForCurrentProduct
  };

})(window, jQuery);
